export default {"src":"/_next/static/media/cannedfood.242406df.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};